import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Employee, EmployeeIdentifier } from '../interfaces/client-data';
import { Observable } from 'rxjs';
import { IProfilePicture } from '../interfaces/profile-picture';

@Injectable({
    providedIn: 'root',
})
export class EmployeeService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/employee').replace('{version}', this.version);

    constructor(private http: HttpClient) {}

    getCurrentUsersEmployeeRecord(): Observable<Employee> {
        return this.http.get<Employee>(this._url + '/GetCurrentUsersEmployeeRecord');
    }

    isEmailUnique(email: string, primaryIdentifier: string): Observable<boolean> {
        return this.http.post<boolean>(this._url + '/IsEmailUnique', {
            email: email,
            identifier: primaryIdentifier,
        });
    }

    getEmployeeIdentifierFromEmail(email: string): Observable<string> {
        return this.http.post<string>(this._url + '/GetEmployeeIdentifierByEmail', {
            email: email,
        });
    }

    getAllEmployeeIdentityRecords(primaryIdentifier: string): Observable<EmployeeIdentifier[]> {
        return this.http.post<EmployeeIdentifier[]>(this._url + '/GetEmployeeIdentifierRecords', {
            identifier: primaryIdentifier,
        });
    }

    GetEmployeeRecordByIdentifier(primaryIdentifier: string): Observable<Employee> {
        return this.http.post<Employee>(this._url + '/GetEmployeeRecordByIdentifier', {
            identifier: primaryIdentifier,
        });
    }

    getAllEmployees(): Observable<Employee[]> {
        return this.http.get<Employee[]>(this._url + '/GetAllEmployees');
    }

    getAllIdentifiersForEmployee(primaryIdentifier: string): Observable<EmployeeIdentifier[]> {
        return this.http.get<EmployeeIdentifier[]>(this._url + '/GetAllIdentifiersForEmployee');
    }

    getAllUserEmployeesForClient(clientShortName: string): Observable<Employee[]> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<Employee[]>(this._url + '/GetAllUserEmployeesForClient', {
            params: params,
        });
    }

    updateEmployeeRequest(formValues): Observable<any> {
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + '/updateEmployeeRequest', formValues).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    updateEmployeeSimpleContact(form): Observable<any> {
        return this.http.post(`${this._url}/contact/simple`, form);
    }

    insertEmployee(formValues): Observable<any> {
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + '/insertNewEmployee', formValues).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }
    updatePowerEmployeeForClient(userToUpdate): Observable<any> {
        const params = {
            loginEmail: userToUpdate.loginEmail,
            isPowerUser: userToUpdate.isPowerUser,
        };
        return this.http.post<any>(this._url + '/PowerUserUpdate', params);
    }
    getAllPowerEmployeesForClient(clientShortName: string = ''): Observable<Employee[]> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<Employee[]>(this._url + '/GetAllPowerEmployeesForClient', {
            params: params,
        });
    }

    doEmployeesExistForClient(clientShortName: string = ''): Observable<boolean> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<boolean>(this._url + '/DoEmployeesExistForClient', {
            params: params,
        });
    }
}
